module.exports = __webpack_public_path__ + "img/LS-M-1.aa774ef7.svg";